var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreerUnDirect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "creer_direct_standard",
    "data-name": "Creer direct standard",
    viewBox: "29.28 34.12 43.5 33.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a5168;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.08,48.22h-6.6v6.69h-2.63v-6.69h-6.57v-2.39h6.57v-6.72h2.63v6.72h6.6v2.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.75,36.99c3.49,3.64,5.64,8.58,5.64,14.03,0,5.45-2.15,10.39-5.64,14.03-.64.68-.62,1.74.05,2.39s1.74.62,2.39-.05c4.08-4.24,6.59-10.01,6.59-16.37s-2.51-12.13-6.58-16.38c-.65-.67-1.72-.69-2.39-.05-.68.64-.7,1.72-.05,2.39h0ZM60.95,51.03c0,3-1.11,5.73-2.96,7.82-.62.7-.55,1.77.15,2.39.7.62,1.77.55,2.39-.15,2.36-2.68,3.8-6.21,3.8-10.06,0-3.85-1.44-7.38-3.8-10.06-.62-.7-1.68-.77-2.39-.15-.7.62-.77,1.68-.15,2.39,1.84,2.09,2.96,4.82,2.96,7.82h0ZM52.5,54.4c1.87,0,3.38-1.51,3.38-3.38s-1.51-3.38-3.38-3.38-3.38,1.51-3.38,3.38,1.51,3.38,3.38,3.38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreerUnDirect);
export default __webpack_public_path__ + "static/media/creer_un_direct.ae9c26fa0d3e2cad08790b15d2ffd86c.svg";
export { ForwardRef as ReactComponent };